import {
  injectFloatingLayout,
  injectFloatingPageClasses,
  provideSystemTabsLayout,
} from '../../../common/helpers/system-tabs-layout/system-tabs-layout';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { ViewSettingWorkingDaysComponent } from './view-setting-working-days/view-setting-working-days.component';
import { EditSettingWorkingDaysComponent } from './edit-setting-working-days/edit-setting-working-days.component';
import { SystemSettingsService } from './system-settings.service';
import { WorkingDaysResponse } from './system-settings-models';
import { workingDays } from './system-settings-constants';
import { TabComponent } from '../../../../ui-components/lib/tabs/tab/tab.component';
import { TabsComponent } from '../../../../ui-components/lib/tabs/tabs.component';
import { ToasterService } from '../../../../ui-components/services/toast/toast.service';
import { OverlayLoaderComponent } from '../../../common/components/overlay-loader/overlay-loader.component';
import { TenantService } from '../../../common/services/tenant/tenant.service';

@Component({
  selector: 'app-system-settings',
  imports: [
    TranslocoPipe,
    TabsComponent,
    TabComponent,
    ViewSettingWorkingDaysComponent,
    EditSettingWorkingDaysComponent,
    OverlayLoaderComponent,
  ],
  providers: [provideSystemTabsLayout()],
  templateUrl: './system-settings.component.html',
  styleUrl: './system-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SystemSettingsComponent implements OnInit, OnDestroy {
  protected readonly floating = injectFloatingLayout();
  protected readonly floatingPageClasses = injectFloatingPageClasses();
  translocoService = inject(TranslocoService);
  systemSettingsService = inject(SystemSettingsService);
  toastService = inject(ToasterService);
  route = inject(ActivatedRoute);
  router = inject(Router);
  tenantService = inject(TenantService);

  editMode = signal<boolean>(false);
  workingDays = signal<WorkingDaysResponse>(workingDays);
  isLoading = signal<boolean>(true);

  destroy$ = new Subject<void>();

  ngOnInit() {
    this.route.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((params: any) => {
        if (params['mode'] === 'edit' || params['mode'] === 'view') {
          this.editMode.set(params['mode'] === 'edit');
          this.getWorkingDays();
        } else {
          this.router.navigate([this.tenantService.tenantPath('')]);
        }
      });
  }

  getWorkingDays() {
    this.isLoading.set(true);
    this.systemSettingsService.getWorkingDays().subscribe({
      next: (res: any) => {
        this.workingDays.set(res);
      },
      error: (error: any) => {
        this.isLoading.set(false);
        this.toastService.add(
          error.error.message,
          '',
          'assets/images/icons/error.svg',
          'error'
        );
      },
      complete: () => {
        this.isLoading.set(false);
      },
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
